export default {
  "common.colon": ": ", // NOTE: これもしかしたら全角のコロンかも？
} as const;
